import Api from '../Base'

class DeleteSpaceAssignment extends Api {
  requestUrl = `/api/SpaceAssignment/${this.getParams().id}`

  method = 'DELETE'
}

export default DeleteSpaceAssignment
